import React from 'react'
import { ButtonSection, ImageLogo, Link, SectionButton } from '../styles'
import Button from 'src/components/common/Button'
import appstore from 'src/assets/logos/appstore.avif'
import googleplay from 'src/assets/logos/googleplay.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
import { RenderButtonsProps } from './types'

export const renderButtons = ({
    referenceApple,
    referencePlay,
    reference,
    webAndApp,
}: RenderButtonsProps) => {
    const t = useTranslations()

    const showWeb = webAndApp !== true && reference
    const showApp = webAndApp !== false && referenceApple && referencePlay

    return (
        <SectionButton>
            {showApp && (
                <>
                    <Link
                        href={referenceApple}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <ImageLogo
                            src={appstore}
                            alt="Download on the App Store"
                        />
                    </Link>
                    <Link
                        href={referencePlay}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <ImageLogo
                            src={googleplay}
                            alt="Get it on Google Play"
                        />
                    </Link>
                </>
            )}
            {showWeb && (
                <ButtonSection
                    href={reference}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button Content={t('cta.website')} />
                </ButtonSection>
            )}
        </SectionButton>
    )
}
